import { render, staticRenderFns } from "./Suspension.vue?vue&type=template&id=e9f6f1cc&"
import script from "./Suspension.vue?vue&type=script&lang=js&"
export * from "./Suspension.vue?vue&type=script&lang=js&"
import style0 from "./Suspension.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports